import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface CheckFieldProps {
  id: string;
  label: string;
  description?: ReactNode;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

/**
 * Belgilash katagi.
 *
 * ATAYLAB haqiqiy `<input type="checkbox">`: klaviatura, `space`, forma
 * bilan bog'lanish va skrinrider e'loni brauzerdan tekin keladi. Rang
 * `accent-color` orqali `--primary` tokenidan olinadi, ya'ni brauzerning
 * standart ko'k rangi hech qayerda qolmaydi.
 */
export const CheckField = ({
  id,
  label,
  description,
  checked,
  onCheckedChange,
  disabled,
  className,
}: CheckFieldProps) => (
  <div className={cn("flex items-start gap-2.5", className)}>
    <input
      id={id}
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={event => onCheckedChange(event.target.checked)}
      className="accent-primary focus-visible:ring-ring mt-0.5 size-4 shrink-0 rounded focus-visible:ring-2 focus-visible:outline-none"
    />
    <div className="min-w-0">
      <label htmlFor={id} className="text-sm leading-tight font-medium">
        {label}
      </label>
      {description && <p className="text-muted-foreground mt-0.5 text-xs">{description}</p>}
    </div>
  </div>
);
